import { render, staticRenderFns } from "./SlyderD.vue?vue&type=template&id=5a56190d&lang=pug&"
import script from "./SlyderD.vue?vue&type=script&lang=js&"
export * from "./SlyderD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports